

jQuery(document).ready(function() {
	console.log("test header");



    


  
		jQuery('#element-template--21138475090009__26d421f6-05e6-4106-968b-2f9995dc3879 h2').attr("aria-level","1");
		jQuery('#shopify-section-template--21138474729561__1752451683c25c6fb6 h2').attr("aria-level","1");

		jQuery('.blog-item__image.increased-spacing').attr("aria-hidden","true");
		jQuery('.blog-item__image.increased-spacing').attr("tabindex","-1");

		jQuery('.contact-form__row label').removeAttr("class");

		jQuery('hr').attr("aria-hidden","true");
		jQuery('br').attr("aria-hidden","true");
		jQuery('.tw-drawer-toggle.svelte-1jkpu3n').attr("aria-hidden","true");
		jQuery('.tw-drawer-toggle.svelte-1jkpu3n').attr("tabindex","-1");

		jQuery('#site-search-sidebar .sidebar__close').attr("aria-label","close search dialog");
		jQuery('#site-cart-sidebar .sidebar__close').attr("aria-label","close cart");
		jQuery('#merchantwidgetiframe').attr("role","presentation");


		jQuery('#in-app-notifications h5, .communities-title').attr("aria-level","2");
		jQuery('#in-app-notifications').attr("aria-label","notification");
		jQuery('#element-template--21138474729561__video_WDBNpi a').attr("aria-label","Play Pizza Making 101 video");
		jQuery('#element-template--21138474729561__video_i8amc9 a').attr("aria-label","Play Sauce Talk video");
		jQuery('#element-template--21138474729561__video_XmzKmV a').attr("aria-label","Play Biz Velatini's Weight-Loss Pizza Recipe video");
		jQuery('#element-template--21138474729561__video_i8amc9 h3, #element-template--21138475548761__video_LGLEFY h3').attr("role","none");
		jQuery('#alia-vv18tlldo1331r41 p').attr("role","heading");
		jQuery('#alia-vv18tlldo1331r41 p').attr("aria-level","2");
		jQuery('#shopify-section-template--21138474729561__video_WDBNpi h3').attr("aria-level","2");

        
    jQuery('iframe[title="Cheesy Bread Sticks on a Baking Steel"]').attr('aria-label', 'Video: Cheesy Bread Sticks on a Baking Steel');

		jQuery('.contact-form__row input').removeAttr("placeholder");
		jQuery('.contact-form__row textarea').removeAttr("placeholder");



    
    
		jQuery('#shopify-section-template--21138474270809__image_dTY3Wg img').attr("alt",'Make something legendary this season and shop baking steels');
		jQuery('#element-952fefed-52fc-4548-99ec-18780f45edd4 img').attr("alt",'Food and wine logo');
		jQuery('#element-cb83a160-9292-467c-a153-9199925931bb img').attr("alt",'Reddit logo');
		jQuery('#element-cb83a160-9292-467c-a153-9199925931bb img').attr("alt",'Reddit logo');
		jQuery('#element-3e0a2bdb-d051-44e4-83f3-1afa320bde87 img').attr("alt",'The wall street journal logo');
		jQuery('#element-template--16437919940841__a2fc738d-a3ef-4d4c-a4b8-23e75b776a2d-16653952481cdb62be-0 img').attr("alt",'Bon Appe logo');
    jQuery('.button.button--outline.element--hide-on-small.button--icon').attr("aria-label","Learn more about the baking steel original")
    jQuery('.product-item__title h3').attr("role","none")
    jQuery('.bundler-container').attr("role","complementary")
    jQuery('.bundler-container').attr("aria-label","Bundle contents")
   // jQuery('.logo-img.logo-img--desk-only').attr("alt","Baking Steel Logo – Home")
    jQuery('.logo-img.logo-img--desk-only').attr("aria-label","Go to Home Page (Baking Steel Logo)")
    jQuery('#site-search-sidebar .sidebar__title').attr("role","heading")
    jQuery('#site-search-sidebar .sidebar__title').attr("aria-level","2")
    jQuery('#site-cart-sidebar .sidebar__title').attr("role","heading")
    jQuery('#site-cart-sidebar .sidebar__title').attr("aria-level","2")
    jQuery('.popup--cookies .popup-title').attr("role","heading")
    jQuery('.popup--cookies .popup-title').attr("aria-level","2")
    jQuery(".alert__icon svg").attr("aria-hidden","true");

    
		jQuery('#site-header').attr("role","banner");
		jQuery('.submenu.normal-menu').attr("role","menu");
		jQuery('.submenu.normal-menu a').attr("role","menuitem");
	//	jQuery('.before-after--desktop-medium').attr("role","button");
	//	jQuery('.before-after--desktop-medium').attr("tabindex","0");
	//	jQuery('.before-after--desktop-medium').attr("aria-label","Use left and right arrow keys to compare before and after");
		jQuery('#section-template--21138474270809__before_after_gaE8JK h2').attr("role","presentation");
		jQuery('.footer-item__menu').attr("role","list");
		jQuery('.footer-item__menu span').attr("role","listitem");

  

		jQuery('#shopify-section-template--21138474270809__slideshow_7P4TiA h2').attr("aria-level","1");
		jQuery('#element-template--21138474270809__1662457498c47086cb h2').attr("aria-level","3");
		jQuery('#element-template--21138474270809__rich_text_9KQDrT h2, #element-template--21138474270809__rich_text_bPDHg7 h2').attr("aria-level","3");
		jQuery('.footer-item__title').attr("aria-level","2");

    

		jQuery('#shopify-section-template--21138474270809__slideshow_7P4TiA a').attr("aria-label","“Learn more about the Original Baking Steel");
		jQuery('#element-1664890690c0b1684f-0 a').attr("aria-label","Shop now for Steels");
		jQuery('#element-1664890690c0b1684f-1 a').attr("aria-label","Shop now for Griddles");
		jQuery('#element-1664890690c0b1684f-2 a').attr("aria-label","Shop now for Cooking Tools");
		jQuery('#image_GRj4Bm img').attr("alt","Before image: Pizza baked on pizza stone for 8 minutes.");
		jQuery('#image_w7YVqJ img').attr("alt","After image: Pizza baked on Baking Steel for 4 minutes.");

        jQuery('a[href="https://www.facebook.com/BakingSteel"]').attr('aria-label', 'Facebook - Baking steel, opens in new tab');
        jQuery('a[href="https://www.instagram.com/bakingsteel/"]').attr('aria-label', 'Instagram - Baking steel, opens in new tab');
        jQuery('a[href="https://www.kickstarter.com/projects/bakingsteel/baking-steel-create-the-crust-you-crave"]').attr('aria-label', 'kickstarter - Baking steel, opens in new tab');
        jQuery('a[href="https://www.linkedin.com/company/baking-steel/"]').attr('aria-label', 'linkedin - Baking steel, opens in new tab');
        jQuery('a[href="https://www.tiktok.com/@bakingsteel"]').attr('aria-label', 'tiktok - Baking steel, opens in new tab');
        jQuery('a[href="https://x.com/bakingsteel"]').attr('aria-label', 'X - Baking steel, opens in new tab');
        jQuery('a[href="https://www.youtube.com/channel/UCpG81Xa-wHu8P7s_RjzBaBg"]').attr('aria-label', 'youtube - Baking steel, opens in new tab');


	//jQuery('a[href="/san-bernardino-retirement-home/"]').attr('aria-label', ariaLabel);
	//jQuery('a:contains("Ask a question!")').attr('aria-label', 'Ask a question!');
   setTimeout(() => {
              jQuery('#in-app-notifications').attr("aria-label","Open Notification");
            }, 1000);
   });
   

   jQuery(document).ready(function(){ 
    setTimeout(function(){ 

       jQuery('.d-inline').attr("aria-level","2");
		   jQuery('.d-inline#current-month').attr("aria-live","polite");
       jQuery('.product-recommendations .section-heading__title').attr("role","heading")
       jQuery('.product-recommendations .section-heading__title').attr("aria-level","2")
      jQuery("product-bundler [data-js-product-add-to-cart]").attr("aria-live","polite");
        jQuery('#in-app-notifications h5, .communities-title').attr("aria-level","2");
        jQuery('.tw-drawer-toggle.svelte-1jkpu3n').attr("aria-hidden","true");
        jQuery('.tw-drawer-toggle.svelte-1jkpu3n').attr("tabindex","-1");

        jQuery('.contact-form__row input').removeAttr("placeholder");
		jQuery('.contact-form__row textarea').removeAttr("placeholder");

       
     },
  4000); 
});


jQuery(document).ready(function () {
  jQuery('#footer-block-menu_ta7b8c').append(
    '<div class="accessibility-badge">' +
      '<a href="https://accessdesignstudio.com/" target="_blank" rel="noopener noreferrer">' +
        '<img src="https://cdn.shopify.com/s/files/1/1250/2125/files/Accessibility_Compliance_Badge_JAN_2026.png?v=1767895089" alt="Accessibility Compliance Badge">' +
      '</a>' +
    '</div>'
  );
});



jQuery(document).ready(function(){ 
    setTimeout(function(){ 

        jQuery('#alia-vv18tlldo1331r41 p').attr("role","heading");
        jQuery('#alia-vv18tlldo1331r41 p').attr("aria-level","2");
        jQuery('#alia-l9b75aaw8pvddix1').attr("alt","Baking Steel logo");
        jQuery('#alia-8zwsimt00cqe4hh1 span').attr("role","button");
        jQuery('#alia-8zwsimt00cqe4hh1 span').attr("tabindex","0");
        jQuery('#alia-8zwsimt00cqe4hh1 span').attr("aria-label","Close Mystery Discount");
        jQuery('#alia-oyoa7dh1jy6jqxr7').attr("role","presentation");
        document.addEventListener('keydown', function (e) {
  if (e.key === 'Enter') {
    const btn = document.activeElement;

    if (btn && btn.matches('#alia-8zwsimt00cqe4hh1 span')) {
      e.preventDefault();
            e.stopPropagation();
      btn.click();
    }
  }
});
      //  jQuery('#alia-popup-root-alia-oyoa7dh1jy6jqxr7').attr("role","dialog");
      //  jQuery('#alia-popup-root-alia-oyoa7dh1jy6jqxr7').attr("aria-model","true");
      //  jQuery('#alia-popup-root-alia-oyoa7dh1jy6jqxr7').attr("aria-label","Join Founder Club”");
          

     },
  10000); 
});

/*
jQuery(document).ready(function() {
    // Select all original price elements
    jQuery('.product-price--original.pps').each(function() {
        var $priceElement = jQuery(this);
        var currentHtml = $priceElement.html();

        // Replace 'Rs.' with the screen-reader-correct version
        if (currentHtml.indexOf('Rs.') !== -1) {
            var updatedHtml = currentHtml.replace('Rs.', '<span aria-label="Rupees">Rs.</span>');
            $priceElement.html(updatedHtml);
        }
    });
});
*/

jQuery(function ($) {
  $('.post h5').each(function () {
    const content = $(this).html(); // preserve <strong><em>...</em></strong>
    $('<figcaption>' + content + '</figcaption>').replaceAll(this);
  });
});

jQuery(function ($) {
  $('.article__content h5').each(function () {
    const content = $(this).html(); // preserve <strong><em>...</em></strong>
    $('<figcaption>' + content + '</figcaption>').replaceAll(this);
  });
});

jQuery(function ($) {
  $('.bundler-product__remove').on('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault(); // Prevent page scroll on Space
      $(this).trigger('click');
    }
  });
});
 

jQuery(function ($) {
  $('iframe[src*="youtube.com/embed"]').each(function () {
    let src = $(this).attr('src');

    if (src && !src.includes('cc_load_policy=1')) {
      // Check if URL already has query params
      const separator = src.includes('?') ? '&' : '?';
      $(this).attr('src', src + separator + 'cc_load_policy=1');
    }
  });
});




jQuery(document).ready(function ($) {
// --- 1. HANDLE TOGGLE BUTTON (Click handles Mouse + Enter + Space) ---
  $('.has-submenu > .menu-link').on('keydown', function (e) {

  if (e.key === 'Enter') {

    e.preventDefault();

    e.stopPropagation();



    const href = this.getAttribute('href');

    if (href) {

      window.location.href = href;

    }

  }

});
    // Use 'click' instead of 'keydown' to support NVDA/Narrator
    $('.submenu-toggle').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const $toggle = $(this);
        const $parent = $toggle.closest('.has-submenu');
        
        // Check current state
        const isExpanded = $toggle.attr('aria-expanded') === 'true';

        if (isExpanded) {
            // CLOSE ACTION
            closeSubmenu($parent);
        } else {
            // OPEN ACTION
            // Optional: Close other open menus first (Accordion behavior)
            // $('.has-submenu.open').each(function() { closeSubmenu($(this)); });

            $parent.addClass('focus'); // Use a class to handle display via CSS
            $toggle.attr('aria-expanded', 'true');
        }
    });

    function keepMenuOpen($parent) {
        // We use a tiny timeout to override any theme script that tries to close it
        setTimeout(function() {
            $parent.addClass('focus');
            $parent.find('.submenu-toggle').attr('aria-expanded', 'true');
        }, 10);
    }

    // --- 2. HANDLE SUBMENU NAVIGATION ---
    // We target links inside .submenu-holder specifically
    $('.has-submenu .submenu a').on('keydown', function(e) {
        
        const $currentLink = $(this);
        // Find the parent container (the <li> with class .has-submenu)
        const $parent = $currentLink.closest('.has-submenu'); 
        
        // Find all links inside this specific menu
        const $links = $parent.find('.submenu a');
        const index = $links.index($currentLink);
        const lastIndex = $links.length - 1;

        // --------------------------------------------------
        // CASE A: ARROW UP (OR SHIFT+TAB)
        // Move to PREVIOUS item
        // --------------------------------------------------
        if (e.key === 'ArrowUp' || (e.shiftKey && e.key === 'Tab')) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation(); // Stops theme scripts on the same element

            if (index > 0) {
                // If not the first item, go to previous
                $links.eq(index - 1).focus();
                keepMenuOpen($parent); // Ensure it stays open
            } else {
                // If it IS the first item, loop to bottom OR go back to toggle button?
                // Standard Accessbility usually says: Go back to the toggle button
                const $toggle = $parent.find('.submenu-toggle');
                $toggle.focus();
                // We do NOT call keepMenuOpen here because user might be leaving
            }
        }

        // --------------------------------------------------
        // CASE B: ARROW DOWN (OR TAB)
        // Move to NEXT item
        // --------------------------------------------------
        if (e.key === 'ArrowDown' || (!e.shiftKey && e.key === 'Tab')) {
            // We only intercept TAB if it's NOT the last item
            // If it is the last item, let the browser Tab naturally (exit the menu)
            if (e.key === 'Tab' && index === lastIndex) {
                 return; // Allow natural tab exit
            }

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            if (index < lastIndex) {
                // Go to next item
                $links.eq(index + 1).focus();
                keepMenuOpen($parent);
            } else {
                // If on last item and pressing ArrowDown, loop to top
                $links.eq(0).focus();
                keepMenuOpen($parent);
            }
        }

        // --------------------------------------------------
        // CASE C: ESCAPE
        // Close the menu
        // --------------------------------------------------
        if (e.key === 'Escape') {
            e.preventDefault();
            e.stopPropagation();
            
            // Close logic
            $parent.removeClass('focus');
            const $toggle = $parent.find('.submenu-toggle');
            $toggle.attr('aria-expanded', 'false');
            $toggle.focus();
        }
    });
    // --- 3. HELPER FUNCTION ---
    // Keeps code DRY (Don't Repeat Yourself)
    function closeSubmenu($parent) {
        $parent.removeClass('focus');
        const $toggle = $parent.find('.submenu-toggle');
        $toggle.attr('aria-expanded', 'false');
        
        // CRITICAL for Accessibility: Return focus to the button
        $toggle.focus();
    }

    // --- 4. INITIAL SETUP ---
    // Ensure all toggles start as closed
    $('.submenu-toggle').attr('aria-expanded', 'false');

    // Optional: Close menu if clicking outside
    $(document).on('click', function(event) {
        if (!$(event.target).closest('.has-submenu').length) {
            $('.has-submenu.focus').each(function() {
                closeSubmenu($(this));
            });
        }
    });
    var $searchSidebar = $('#site-search-sidebar');
    var $focusTarget   = $('#header-top > a.area--search.icon-button.icon-button--text-tooltip');

    // Listen for keys specifically inside the search sidebar
    $searchSidebar.on('keydown', function(e) {
        
        // Find all focusable elements inside the sidebar
        var focusableItems = $searchSidebar.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
        
        var $firstEl = focusableItems.first();
        var $lastEl  = focusableItems.last();

        // --- 1. ESCAPE KEY LOGIC ---
        if (e.key === 'Escape' || e.keyCode === 27) {
            e.preventDefault();
            
            // Move focus back to the header area
            // We ensure it has a tabindex just in case it's a div/span
            setTimeout(function() { 
            $focusTarget.focus();
            }, 200);
            // OPTIONAL: If the sidebar doesn't close automatically, 
            // you might want to trigger the close button here too:
            // $searchSidebar.find('.close-button-class').trigger('click');
        }

        // --- 2. TAB KEY TRAP LOGIC ---
        if (e.key === 'Tab' || e.keyCode === 9) {
            
            // SHIFT + TAB (Backwards)
            if (e.shiftKey) { 
                if (document.activeElement === $firstEl[0]) {
                    e.preventDefault();
                    $lastEl.focus(); // Loop to bottom
                }
            } 
            // TAB (Forwards)
            else { 
                if (document.activeElement === $lastEl[0]) {
                    e.preventDefault();
                    $firstEl.focus(); // Loop to top
                }
            }
        }
    });
    (function () {
  let lastAction = null;

  // Capture which button was clicked
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.qty-button');
    if (!btn) return;

    const item = btn.closest('[data-js-cart-item]');
    if (!item) return;

    lastAction = {
      line: item.getAttribute('data-line'),
      isPlus: btn.classList.contains('qty-plus')
    };
  }, true);

  // Observe AjaxCartForm replacement
  const target = document.getElementById('AjaxCartForm');
  if (!target) return;

  const observer = new MutationObserver(() => {
    if (!lastAction) return;

    const item = document.querySelector(
      `[data-js-cart-item][data-line="${lastAction.line}"]`
    );
    if (!item) return;

    const selector = lastAction.isPlus ? '.qty-plus' : '.qty-minus';
    const btn = item.querySelector(selector);

    if (btn) {
      btn.focus();
      lastAction = null;
    }
  });

  observer.observe(target, {
    childList: true,
    subtree: true
  });
})();
    // --- CONFIGURATION ---
    var $cartTrigger = $('.area--cart');
    var $cartSidebar = $('#site-cart-sidebar');
    // We try to find a close button inside the sidebar. 
    // Adjust '.close-cart-class' if your theme uses a specific class like .pxl-close-cart
    var $closeBtn    = $cartSidebar.find('.pxl-close-cart, .close-btn, .widget_shopping_cart_close');

    // 1. OPENING: When clicking the Cart Icon
    $cartTrigger.on('click keydown', function(e) {
        // Allow Click or Enter key
        if (e.type === 'keydown' && e.key !== 'Enter' && e.keyCode !== 13) return;

        // Note: We assume your theme already handles the "slide out" animation.
        // We just handle the FOCUS movement.
        
        $cartTrigger.attr('aria-expanded', 'true');

        // Wait 100ms for the sidebar to slide in/display
        setTimeout(function() {
            var $focusable = $cartSidebar.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
            
            if ($focusable.length) {
                $focusable.first().focus();
            } else {
                // Fallback if empty cart
                $cartSidebar.attr('tabindex', '-1').focus();
            }
        }, 100);
    });

    // 2. FOCUS TRAP & ESCAPE (Inside Sidebar)
    $cartSidebar.on('keydown', function(e) {
        
        var $focusableEls = $cartSidebar.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
        var $firstTab = $focusableEls.first();
        var $lastTab  = $focusableEls.last();

        // A. ESCAPE KEY: Close and Return Focus
        if (e.key === 'Escape' || e.keyCode === 27) {
            e.preventDefault();
            
            // Trigger the theme's close logic (simulating a click on the close button usually works)
            if ($closeBtn.length) {
                $closeBtn.trigger('click');
               
            } else {
                // Fallback: simply hide it if no close button found (rare)
                $cartSidebar.removeClass('active open'); // Add your theme's open class here if known
            }

             setTimeout(() => {
              $('#header-top > .area--cart').focus();
            }, 400);
            $cartTrigger.attr('aria-expanded', 'false');
            return;
        }

        // B. TAB KEY: Trap Focus
        if (e.key === 'Tab' || e.keyCode === 9) {
            // Shift + Tab (Backwards)
            if (e.shiftKey) { 
                if (document.activeElement === $firstTab[0]) {
                    e.preventDefault();
                    $lastTab.focus(); // Wrap to bottom
                }
            } 
            // Tab (Forwards)
            else { 
                if (document.activeElement === $lastTab[0]) {
                    e.preventDefault();
                    $firstTab.focus(); // Wrap to top
                }
            }
        }
    });

    // 3. CLOSING: When clicking the "X" Close Button inside
    // We need to catch this so we can send focus back to the trigger
    if ($closeBtn.length) {
        $closeBtn.on('click', function() {
            $cartTrigger.attr('aria-expanded', 'false');
            setTimeout(() => {
              $('#header-top > .area--cart').focus();
            }, 200);
        });
    }
    var targetId = "alia-root-106755";
    var labelText = "Get access to exclusive Founder classes and secret recipes";

    // Function to apply the label
    function applyLabel() {
        var $element = $('#' + targetId);
        
        // Only apply if element exists AND doesn't have the label yet
        if ($element.length > 0 && $element.attr('aria-label') !== labelText) {
            $element.attr('aria-label', labelText);
            // Optional: If this element only loads once, you can stop observing here to save memory:
            // observer.disconnect(); 
        }
    }

    // 1. Try immediately (in case it's already there)
    applyLabel();

    // 2. Setup MutationObserver to watch for it loading later
    var observer = new MutationObserver(function(mutations) {
        var shouldCheck = false;

        mutations.forEach(function(mutation) {
            // Check if any new nodes were added
            if (mutation.addedNodes.length > 0) {
                shouldCheck = true;
            }
        });

        if (shouldCheck) {
            applyLabel();
        }
    });

    // Start watching the body for changes
    observer.observe(document.body, { 
        childList: true, 
        subtree: true 
    });
    
    // 1. Define the logic to apply accessibility attributes
    function updateCalendarAccessibility() {
        
        // A. Buttons
        $('.previous-month-btn').each(function() {
            if ($(this).attr('aria-label') !== 'Previous Month') {
                $(this).attr('aria-label', 'Previous Month');
            }
        });

        $('.next-month-btn').each(function() {
            if ($(this).attr('aria-label') !== 'Next Month') {
                $(this).attr('aria-label', 'Next Month');
            }
        });

        // B. Current Month Label (Live Region)
        var $monthLabel = $('#current-month');
        if ($monthLabel.length > 0) {
            // Check if we already added the live attribute to avoid spamming the DOM
            if ($monthLabel.attr('aria-live') !== 'polite') {
                $monthLabel.attr({
                    'aria-live': 'assertive',  // Announces changes politely
                    'aria-atomic': 'true',  // Reads the full date, not just the changed word
                    'role': 'alert'        // Helps some screen readers identify it as status text
                });
            }
        }
    }

    // 2. Run immediately (for initial page load)
    updateCalendarAccessibility();

    // 3. Setup MutationObserver to watch for calendar updates
    var observer = new MutationObserver(function(mutations) {
        var shouldRun = false;

        mutations.forEach(function(mutation) {
            // Check if nodes were added (calendar rebuild) 
            // OR if attributes changed (in case text changes without rebuilding)
            if (mutation.type === 'childList' || mutation.type === 'characterData') {
                shouldRun = true;
            }
        });

        if (shouldRun) {
            updateCalendarAccessibility();
        }
    });

    // 4. Start observing the body
    // We watch 'subtree' to catch the calendar changing deep inside the page
    observer.observe(document.body, { 
        childList: true, 
        subtree: true,
        characterData: true // Also watch for simple text changes inside the month label
    });
    // Global variable to remember which link opened the modal
    var lastFocusedTrigger = null;

    // --- 1. MUTATION OBSERVER: Handle Attributes dynamically ---
    // This ensures that if the calendar/modal reloads via Ajax, attributes are re-applied.
    function setupModalAttributes() {
        var $modal = $('#tsc--eventModal');
        var $closeBtn = $modal.find('.tscModalCloseButton');

        // A. Setup Modal Container
        if ($modal.length && $modal.attr('role') !== 'dialog') {
            $modal.attr({
                'role': 'dialog',
                'aria-modal': 'true',
                'tabindex': '0' // Allows programmatic focus to the container itself if needed
            });
        }

        // B. Setup Close Button
        if ($closeBtn.length && $closeBtn.attr('aria-label') !== 'Close dialog') {
            $closeBtn.attr({
                'tabindex': '0',        // Make div/span focusable
                'role': 'button',       // Semantics
                'aria-label': 'Close dialog'
            });
        }
        $(".tscModalImageLink,.tscModalAddressLink").attr("tabindex","-1");
    }

    // Initialize Observer
    var observer = new MutationObserver(function(mutations) {
        // Run the setup whenever the DOM changes
        setupModalAttributes();
    });

    // Start Observing
    observer.observe(document.body, { childList: true, subtree: true });
    
    // Run once immediately
    setupModalAttributes();


    // --- 2. OPEN LOGIC: Click on Link ---
    // We use $(document).on to handle links that might be added dynamically later
    $(document).on('click keydown', '.tsc--eventModalLink', function(e) {
        if (e.type === 'keydown' && e.key !== 'Enter' && e.keyCode !== 13) return;

        // 1. Save the trigger so we can return focus later
        lastFocusedTrigger = $(this);
        var linkText = $(this).text().trim();
        
        // We apply it to the modal immediately
        $('#tsc--eventModal').attr('aria-label', linkText);
        // 2. Move Focus into Modal
        // We wait 100ms for the modal to visually appear
        setTimeout(function() {
            var $modal = $('#tsc--eventModal');
            
            // Find first interactive element inside
            var $focusable = $modal.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');

            if ($focusable.length) {
                $focusable.first().focus();
            } else {
                // Fallback: focus the close button
                $modal.find('.tscModalCloseButton').focus();
            }
        }, 100);
    });


    // --- 3. FOCUS TRAP & CLOSE LOGIC ---
    // We attach this to the document so it works even if the modal is rebuilt
    $(document).on('keydown', '#tsc--eventModal', function(e) {
        
        var $modal = $(this);
        var $closeBtn = $modal.find('.tscModalCloseButton');

        // A. ESCAPE KEY -> Trigger Close
        if (e.key === 'Escape' || e.keyCode === 27) {
            e.preventDefault();
            e.stopPropagation();
            $modal.removeClass("show");
            $closeBtn.trigger('click'); // Simulate click to close
            return;
        }

        // B. TAB KEY -> Trap Focus
        if (e.key === 'Tab' || e.keyCode === 9) {
            var $focusable = $modal.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
            var $first = $focusable.first();
            var $last  = $focusable.last();

            // Shift + Tab (Backwards)
            if (e.shiftKey) {
                if (document.activeElement === $first[0]) {
                    e.preventDefault();
                    $last.focus(); // Wrap to bottom
                }
            } 
            // Tab (Forwards)
            else {
                if (document.activeElement === $last[0]) {
                    e.preventDefault();
                    $first.focus(); // Wrap to top
                }
            }
        }
    });


    // --- 4. RETURN FOCUS ON CLOSE ---
    // Detect when the close button is clicked (by mouse, Enter, or our Esc trigger above)
    $(document).on('click keydown', '.tscModalCloseButton', function(e) {
        if (e.type === 'keydown' && e.key !== 'Enter' && e.keyCode !== 13) return;
        $("#tsc--eventModal").removeClass("show");
        if (lastFocusedTrigger) {
            // Wait for modal to hide, then restore focus
            setTimeout(function() {
                lastFocusedTrigger.focus();
            }, 50);
        }
    });
    $('#site-cart-sidebar').on('keydown', function (e) {
  if (e.key !== 'Tab') return;

  const $focusable = $(this).find(
    'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
  ).filter(':visible');

  const first = $focusable.first()[0];
  const last  = $focusable.last()[0];

  if (e.shiftKey) {
    if (document.activeElement === first) {
      e.preventDefault();
      last.focus();
    }
  } else {
    if (document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }
});
// --- 1. DEFINITIONS: Structure & Setup Functions ---

function structureNotifications() {
    $('.tw-dropdown-content-inner').each(function () {
        var $container = $(this);

        // A. Find notification items NOT already inside <li>
        var $items = $container
            .find('.tw-notification')
            .not('li .tw-notification');

        if (!$items.length) return;

        // B. Wrap each NEW notification in <li>
        $items.wrap('<li class="pxl-notification-li"></li>');

        // C. Check if a UL already exists
        var $existingUl = $container.find('ul.pxl-notification-ul');
        var $newListItems = $container.find('.pxl-notification-li').not('.pxl-notification-ul .pxl-notification-li');

        if ($existingUl.length > 0) {
            // If UL exists, move new LIs into it
            $existingUl.append($newListItems);
        } else {
            // If no UL, wrap all LIs into a new UL
            var $allListItems = $container.find('.pxl-notification-li');
            $allListItems.wrapAll('<ul class="pxl-notification-ul" role="list"></ul>');
        }
    });
}

function setupNotifications() {
    // Ensure all notifications (new and old) have accessibility attributes
    $('.tw-dropdown-content-inner').find('.tw-notification').attr({
        'tabindex': '0',
        'role': 'link'
    });
}

// --- 2. MUTATION OBSERVER (The New Part) ---
// This watches for new content added to the notification area

var observerTarget = document.querySelector('.tw-dropdown-content-inner');

if (observerTarget) {
    var observer = new MutationObserver(function(mutations) {
        var shouldUpdate = false;
        
        // Check if nodes were actually added
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length > 0) {
                shouldUpdate = true;
            }
        });

        // Only run if new content was detected
        if (shouldUpdate) {
            // Temporarily disconnect to prevent infinite loops while we modify DOM
            observer.disconnect();
            
            structureNotifications();
            setupNotifications();
            
            // Reconnect
            observer.observe(observerTarget, { childList: true, subtree: true });
        }
    });

    // Start Observing
    observer.observe(observerTarget, { childList: true, subtree: true });
}


// --- 3. INITIAL RUN ---
$(document).ready(function() {
    structureNotifications();
    setupNotifications();
});


// --- 4. INTERACTION LOGIC (Mouse & Keyboard Fix) ---

var $triggerWrapper = $('#in-app-notifications'); 
var $dropdown = $('.tw-dropdown-content-inner');

// A. OPENING & TOGGLING
$triggerWrapper.on('click keydown', function(e) {
    // Filter: Allow Click or Enter Key only
    if (e.type === 'keydown' && e.key !== 'Enter' && e.keyCode !== 13) return;

    // Case: KEYBOARD (Enter Key)
    if (e.type === 'keydown') {
        e.preventDefault(); 
        $triggerWrapper.addClass('tw-dropdown-open');

        // Move Focus Inside (Only for keyboard)
        setTimeout(function() {
            var $firstItem = $dropdown.find('.tw-notification').first();
            if ($firstItem.length) $firstItem.focus();
        }, 50);
    } 
    // Case: MOUSE (Click)
    else if (e.type === 'click') {
        // Simple Toggle
        $triggerWrapper.toggleClass('tw-dropdown-open');
    }
});

// B. PREVENT ACCIDENTAL CLOSING (Focusout)
$triggerWrapper.on('focusout', function(event) {
    setTimeout(function() {
        var $newFocus = $(document.activeElement);
        // If focus is still inside wrapper or dropdown, keep open
        if ($triggerWrapper.find($newFocus).length > 0) {
             $triggerWrapper.addClass('tw-dropdown-open'); 
        } else {
            $triggerWrapper.removeClass('tw-dropdown-open');
        }
    }, 10);
});

// C. ESCAPE KEY (Close)
$triggerWrapper.on('keydown', function(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
        e.preventDefault();
        e.stopPropagation();
        $triggerWrapper.removeClass('tw-dropdown-open');
        
        var $btn = $triggerWrapper.is('button, a, [tabindex]') ? $triggerWrapper : $triggerWrapper.find('button, a').first();
        $btn.focus();
    }
});

// D. ENTER KEY ON ITEMS
$dropdown.on('keydown', '.tw-notification', function(e) {
    if (e.key === 'Enter' || e.keyCode === 13) {
        $(this).click();
    }
});
// 1. Define the elements
const modalId = 'alia-root-106755';

// We attach the listener to the window in the "Capture Phase" 
// to ensure we intercept the keystroke before ANY other library does.
window.addEventListener('keydown', function(e) {
    
    // Only run this logic if the specific modal exists and is visible
    const modal = document.getElementById(modalId);
    if (!modal || modal.style.display === 'none') return;

    // Check for Tab key
    const isTab = (e.key === 'Tab' || e.keyCode === 9);
    if (!isTab) return;

    // specific elements (using selectors to be safe against dynamic IDs)
    const closeBtn = modal.querySelector('[aria-label="Close popup"]');
    const emailInput = modal.querySelector('input[name="email"]');
    const submitBtn = modal.querySelector('button[type="submit"]');

    // --- SHIFT + TAB (Backward Direction) ---
    if (e.shiftKey) {
        // CASE 1: currently on Close Button -> Loop to Continue Button
        if (document.activeElement === closeBtn) {
            e.preventDefault();
            e.stopImmediatePropagation(); // STOP conflicting scripts
            submitBtn.focus();
        }
        // CASE 2: currently on Email Input -> Move back to Close Button
        else if (document.activeElement === emailInput) {
            e.preventDefault();
            e.stopImmediatePropagation(); // STOP conflicting scripts
            closeBtn.focus();
        }
        // CASE 3: currently on Continue Button -> Move back to Email Input
        else if (document.activeElement === submitBtn) {
            e.preventDefault();
            e.stopImmediatePropagation(); // STOP conflicting scripts
            emailInput.focus();
        }
    }
    
    // --- TAB ONLY (Forward Direction) ---
    else {
        // We also need to fix the loop here so the bad script doesn't interfere
        if (document.activeElement === submitBtn) {
            e.preventDefault();
            e.stopImmediatePropagation();
            closeBtn.focus();
        }
    }

}, true); // <--- THE "true" HERE IS CRITICAL. It enables Capture Phase.
});






 
